import React from "react";
import AdultsLandingPage from "../Components/AdultsLandingPage";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import '../Styles/CampsAdults.scss';
import {Helmet} from "react-helmet";

function CampsAdults() {
   return (
      <div>
         <Helmet>
            <title>Adult Events And Retreats - Camp Connect</title>
         </Helmet>
         <div className = "adultsNavbar">
            <Navbar/>
         </div>
         <AdultsLandingPage/>
         <Footer/>

      </div>
   )
};

export default CampsAdults;
